import { render } from "./NavigationTop.vue?vue&type=template&id=53d9ba8f&scoped=true&ts=true&lang=pug"
import script from "./NavigationTop.vue?vue&type=script&lang=ts"
export * from "./NavigationTop.vue?vue&type=script&lang=ts"

import "./NavigationTop.vue?vue&type=style&index=0&id=53d9ba8f&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./NavigationTop.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/navigation/navigationTop.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fnavigation%2FNavigationTop.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d9ba8f"]])

export default __exports__